// a notification inbox component

import { init, classModule,toVNode, propsModule, styleModule, datasetModule, eventListenersModule, h } from 'snabbdom';
import Core from 'hvx/modules/CoreModule';
import { delegate } from './helpers';
import { itemView } from './components';
const patch = init([
  classModule,
  propsModule,
  styleModule,
  datasetModule,
  eventListenersModule,
]);

export default class Inbox {
  /**
   * 
   * @param {NotificationStore} store 
   * @returns 
   **/
  constructor(store, options) {
    const option = options || {};
    if (Inbox._instance) {
      return Inbox._instance;
    }
    Inbox._instance = this;
  
    this._isWindowOpen = false;
    this._window = null;
    console.log(this._window);
    this.notificationStore = store;
    this.el = document.createElement('div');
    this.emptyPlaceholder = document.createElement('h3');
    this.emptyPlaceholder.classList.add('empty-placeholder');
    this.emptyPlaceholder.innerHTML = 'Your Inbox is Empty';
    this.el.appendChild(this.emptyPlaceholder);
    this.inboxListContainer = document.createElement('div');
    this.inboxListContainer.classList.add('inbox-list-container');
    this.el.appendChild(this.inboxListContainer);

    this.el.classList.add('notify-inbox-container');
    this.vnode = toVNode(this.inboxListContainer);
    
    this.useLocalTime = option.useLocalTime || true;
    Core.EventManager.addListener('hvx.notification.toggle', this._onWindowToggle.bind(this));

    store.addEventListener('save', () => {
      if (this._window) {
        this.render();
      }
    });
    this._bindEvents();
  }
  _bindEvents() {
    delegate(document, '.inbox-toggle', 'click', this._toggleInbox.bind(this));
  }
  _toggleInbox(e) {
    e.preventDefault();
    e.stopPropagation();
    this.el.classList.toggle('open');
  }
  _createWindow() {
    const element = document.getElementById('cMainComponent-body');
    // get the bounding rectangle of the element
    const rect = element.getBoundingClientRect();
    // eslint-disable-next-line no-undef
    return Ext.create('Ext.window.Window', {
      title: 'Notification Center',
      cls: 'notify-inbox-window',
      renderTo: 'cMainComponent-body',
      constrain: true,
      constrainTo: element,
      width: 500,
      height: 500,
      y: 10,
      x: rect.width - 510,
      closeAction: 'hide',
      maximizable: true,
      layout: 'fit',
      listeners: {
        afterrender: (win) =>{
          
          win.body.appendChild(this.el);
          this.render();
        },
        close: () => {
          Core.EventManager.fireEvent('hvx.notification.toggle', false);
          this._isWindowOpen = false;
        },
      }
    });
  }
  /**
   *  toggle the active state of a notification
  * @param {import('./store').NotificationStoreItem} notification
   * 
   */
  _ToggleActive(notification){
    this.notificationStore.toggleActive(notification);

  } 
  _ToggleDetached(notification){
    Core.EventManager.fireEvent('hvx.notification.detials', false);

    this.notificationStore.toggleDetached(notification);
  }
  _onNotificationRead() {
    this.render();
  }
  _onWindowToggle() {
    if (!this._window) {
      this._window = this._createWindow();
    }
    if (!this._isWindowOpen) {
      this._window.show();
      this.render();
      this._isWindowOpen = true;
    } else {
      Core.EventManager.fireEvent('hvx.notification.hasunread', false);
      this.notificationStore.toggleAllRead();
      this._window.hide();
      this._isWindowOpen = false;
    }
  }
  /**
   * @param {import("./notification-item").NotificationStoreItem} notification 
   * @returns 
   */ 
  renderInboxItem(notification) {

    return h('div.notify-item', {
      dataset: {
        id: notification.id
      },
      class: {
        'unread': !notification.read,
      },
      style: {

      },
    }, [
      h('button.notify-detached',{
        on: {
          click: () => {
            this._ToggleDetached(notification);
          }
        }
      }, [h('i.bi.bi-box-arrow-up-right')]),
      itemView(notification, {
        useLocalTime: this.useLocalTime,
        toggleActive: this._ToggleActive.bind(this)
      })
      ,
    ]);  }
  
  render() {
    const notifications = this.notificationStore.all();

    if (notifications.length === 0) {
      this.emptyPlaceholder.style.display = 'block';
      //hide inbox list container
      this.inboxListContainer.style.display = 'none';
      return;
    }
    else{
      this.emptyPlaceholder.style.display = 'none';
      this.inboxListContainer.style.display = 'block';
    }

    const vnode = h('div.notify-inbox-container', [
      
      h('div', { class: { 'inbox-list': true } }, 
        this.notificationStore.all('inbox').map((item) => this.renderInboxItem(item))
      ),
    ]);
    this.vnode = patch(this.vnode, vnode);
  }


}